"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _table = _interopRequireDefault(require("britive-design-system/core/components/table"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _button = _interopRequireDefault(require("britive-design-system/core/components/button"));

var _typography = _interopRequireDefault(require("britive-design-system/core/components/typography"));

var _spinner = _interopRequireDefault(require("britive-design-system/core/components/spinner"));

var _classnames = _interopRequireDefault(require("classnames"));

var _constants = require("./constants");

var _lodash = require("lodash");

var _commonConstants = require("../../utils/common-constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.vault-data-table-empty {\n  vertical-align: middle; }\n\n.vault-data-table-bottom-panel {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 0.0625rem solid #a8a8a8;\n  border-top: none;\n  height: 3.5rem;\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  box-sizing: border-box; }\n\n.no-border {\n  border: none; }\n\n.vault-data-table-wrapper {\n  position: relative; }\n\n.data-table-search-container {\n  position: sticky;\n  z-index: 1;\n  border: 0.0625rem solid #a8a8a8;\n  display: flex;\n  justify-content: flex-end;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  border-bottom: none;\n  min-width: 14.75rem; }\n  .data-table-search-container .search-container {\n    border-color: #a8a8a8; }\n  .data-table-search-container .container {\n    all: unset; }\n";
  var fileName = "compone_DataTable";
  var element = document.querySelector("style[data-sass-component='compone_DataTable']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var DataTable = function DataTable(_ref) {
  var _dataTableBottomPanel;

  var loadMore = _ref.loadMore,
      loadMoreHandler = _ref.loadMoreHandler,
      searchBar = _ref.searchBar,
      rows = _ref.rows,
      columns = _ref.columns,
      loading = _ref.loading,
      loadingMessage = _ref.loadingMessage,
      sortHandler = _ref.sortHandler,
      _ref$inLineSort = _ref.inLineSort,
      inLineSort = _ref$inLineSort === void 0 ? false : _ref$inLineSort;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      sortOrder = _useState2[0],
      setSortOrder = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      sortField = _useState4[0],
      setSortField = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      tableRows = _useState6[0],
      setTableRows = _useState6[1];

  (0, _react.useEffect)(function () {
    setTableRows(rows);
  }, [rows]);
  (0, _react.useEffect)(function () {
    if (inLineSort && !(0, _lodash.isEmpty)(rows) && [_commonConstants.ascendingOrder, _commonConstants.descendingOrder].includes(sortOrder) && !(0, _lodash.isEmpty)(sortField)) {
      inLineSortHandler();
    }
  }, [rows, sortOrder, sortField]);

  var inLineSortHandler = function inLineSortHandler() {
    if (!(0, _lodash.isEmpty)(rows)) {
      setTableRows(function (tableRows) {
        return (0, _lodash.orderBy)(tableRows, [function (data) {
          var _data$sortField2, _data$sortField3;

          var column = columns.find(function (column) {
            return (column === null || column === void 0 ? void 0 : column.field) === sortField;
          });

          if (column !== null && column !== void 0 && column.isNumeric) {
            if ((data === null || data === void 0 ? void 0 : data[sortField]) === _commonConstants.NA_TEXT || (data === null || data === void 0 ? void 0 : data[sortField]) === '') {
              return Number.MAX_SAFE_INTEGER;
            }

            return Number(data === null || data === void 0 ? void 0 : data[sortField]);
          }

          if (column !== null && column !== void 0 && column.isDate) {
            var _data$sortField;

            if ((data === null || data === void 0 ? void 0 : (_data$sortField = data[sortField]) === null || _data$sortField === void 0 ? void 0 : _data$sortField.trim()) === '') {
              return new Date(0);
            }

            return new Date(data === null || data === void 0 ? void 0 : data[sortField]);
          }

          if ((data === null || data === void 0 ? void 0 : (_data$sortField2 = data[sortField]) === null || _data$sortField2 === void 0 ? void 0 : _data$sortField2.trim()) === '') {
            return null;
          }

          return data === null || data === void 0 ? void 0 : (_data$sortField3 = data[sortField]) === null || _data$sortField3 === void 0 ? void 0 : _data$sortField3.toLowerCase();
        }], [sortOrder === _commonConstants.ascendingOrder ? _commonConstants.ascOrder : _commonConstants.descOrder]);
      });
    }
  };

  var localSortHandler = function localSortHandler(sortOrder, fieldName) {
    setSortOrder(sortOrder === _commonConstants.unsortedOrder ? null : sortOrder);
    setSortField(sortOrder === _commonConstants.unsortedOrder ? null : fieldName);
  };

  var props = {
    loadMoreHandler: loadMoreHandler,
    rows: tableRows,
    columns: columns,
    loading: loading,
    resizableColumns: true,
    sortHandler: inLineSort ? localSortHandler : sortHandler,
    searchBar: searchBar
  };
  var dataTableBottomPanelClasses = (_dataTableBottomPanel = {}, _defineProperty(_dataTableBottomPanel, _constants.classes.dataTableBottomPanel, true), _defineProperty(_dataTableBottomPanel, _constants.classes.noBorder, loadMore), _dataTableBottomPanel);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.dataTableWrapper
  }, loading && /*#__PURE__*/_react.default.createElement(_spinner.default, {
    size: _constants.spinnerSize,
    message: loadingMessage || '',
    overlay: true
  }), /*#__PURE__*/_react.default.createElement(_table.default, props), (!loading && rows && rows.length === 0 || loadMore) && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_objectSpread({}, dataTableBottomPanelClasses))
  }, loadMore && /*#__PURE__*/_react.default.createElement(_button.default, {
    variant: _constants.textOnlyBtn,
    size: _constants.mediumBtn,
    onClick: function onClick(e) {
      return loadMoreHandler(e);
    }
  }, _constants.nextDataButtonText), !loading && rows && rows.length === 0 && /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: _constants.typographyCaption
  }, _constants.noDataText)));
};

DataTable.propTypes = {
  loadMore: _propTypes.default.bool,
  loadMoreHandler: _propTypes.default.func,
  searchBar: _propTypes.default.shape({
    onSearch: _propTypes.default.func,
    placeholder: _propTypes.default.string,
    isDisabled: _propTypes.default.bool,
    isSearchEmpty: _propTypes.default.bool
  }).isRequired,
  columns: _propTypes.default.arrayOf(_propTypes.default.shape({
    field: _propTypes.default.string,
    headerName: _propTypes.default.string.isRequired,
    sortable: _propTypes.default.bool,
    width: _propTypes.default.string,
    horizontalAlignment: _propTypes.default.string
  })).isRequired,
  rows: _propTypes.default.arrayOf(_propTypes.default.object),
  loading: _propTypes.default.bool.isRequired,
  loadingMessage: _propTypes.default.string,
  sortHandler: _propTypes.default.func,
  inLineSort: _propTypes.default.bool
};
var _default = DataTable;
exports.default = _default;